import { QtmButton, QtmIcon } from '@qtm/react';
import { useUpdateUserMutation } from 'api/UsersEndPoints';
import dayjs from 'dayjs';
import { UserTableModel } from 'modules/Users/DataTableDef';
import { useRef, useState } from 'react';
import { useClickAway } from 'react-use';
import Loader from 'shared/component/Loader';
import { v4 as uuidv4 } from 'uuid';

type Props = {
  user: UserTableModel;
};

const DataTableRowActions = ({ user }: Props) => {
  const ref = useRef(null);

  const [updateUser, { isLoading }] = useUpdateUserMutation();
  const [open, setOpen] = useState(false);

  useClickAway(ref, () => {
    if (open) {
      setOpen(false);
    }
  }, ['click']);

  const toggleMenu = () => {
    setOpen(!open);
  };

  const onGenerate = async () => {
    const expirationDate = dayjs().add(15, 'days').endOf('day');

    await updateUser({
      id: user.id,
      token: uuidv4(),
      expirationDate: expirationDate.toISOString(),
    });

    setOpen(false);
  };

  const onRemove = async () => {
    await updateUser({
      id: user.id,
      token: '',
    });

    setOpen(false);
  };

  const hasLink = !!user.token;

  return (
    <td ref={ref} className="actions">
      {isLoading && <Loader />}
      {open && (
        <div className="user-context-menu">
          {hasLink && (
            <QtmButton variant="ghost" color="neutral" size="small" onClick={onRemove}>
              Remove link
            </QtmButton>
          )}
          <QtmButton variant="ghost" color="neutral" size="small" onClick={onGenerate}>
            Generate link
          </QtmButton>
        </div>
      )}

      <QtmButton variant="ghost" color="neutral" size="small" onClick={toggleMenu}>
        <QtmIcon icon="more_vert" size="large" />
      </QtmButton>
    </td>
  );
};

export default DataTableRowActions;
